import {CoreState} from './CoreState'
import {CoreView} from './CoreView'

/******************************************************************
 * CoreServices
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class CoreServices {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _coreView: CoreView
    private _coreState: CoreState

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor() {
        // nothing here
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    get view(): CoreView {
        return this._coreView ?? (this._coreView = new CoreView(this))
    }

    get state(): CoreState {
        return this._coreState ?? (this._coreState = new CoreState())
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    // no privtes methodes yet

    /******************************************************************
     * Events
     *****************************************************************/

    // no events yet

}
